import React from 'react';
import styled from 'styled-components';

interface VerticalDividerProps {
  height?: number;
  color?: string;
}

const StyledVerticalDivider = styled.div<VerticalDividerProps>`
  width: 1px;
  height: ${props => props.height || 20}px;
  background-color: ${props => props.color || '#cccccc'};
`;

const VerticalDivider: React.FC<VerticalDividerProps> = ({ height, color }) => {
  return <StyledVerticalDivider height={height} color={color} />;
};

export default VerticalDivider;
